/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */


export class SettingStorage {
  public static getItem(name: string): string | undefined {
    return localStorage.getItem(name) ?? undefined;
  }

  public static setItem(name: string, value: any): void {
    localStorage.setItem(name, value);
  }
}
